<template>
  <v-menu
    offset-y
    full-width
    v-model="menu"
    :close-on-content-click="false"
    nudge-top="24"
  >
    <v-text-field
      :label="label"
      :hint="hint"
      slot="activator"
      v-model="value.name"
      append-icon="arrow_drop_down"
      readonly
      :rules="rules"
    >
    </v-text-field>
    <v-card>
      <v-form v-model="formValid" ref="formRef">

        <v-card-text>
          <v-checkbox
            label="1. 如果该单位属于本单位，请检索并选择。"
            v-model="orgType"
            value="sys"
            class="blue--text body-2"
            hide-details
          />
          <v-text-field
            label="本单位"
            required
            :rules="XRules.sysOrg"
            v-model="sysOrg"
            persistent-hint
            :disabled="orgType !== 'sys'"
          />
          <v-checkbox
            label="2. 如果该单位不属于本单位，请填写单位名称。"
            v-model="orgType"
            value="oth"
            class="blue--text body-2"
            hide-details
          />
          <v-text-field
            label="系统外单位"
            required
            :rules="XRules.othOrg"
            v-model="othOrg"
            hint="输入外单位名称，或系统外的单位名称。"
            persistent-hint
            :disabled="orgType !== 'oth'"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="menu = false">取消</v-btn>
          <v-btn color="primary" @click="onOk">确定</v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-menu>

</template>
<script>
  export default {
    props: ['value', 'label', 'hint', 'rules'],

    data() {
      return {
       // orgURI: '/api/syst/department/',

        menu: false,
        formValid: true,

        orgType: 'sys',
        sysOrg: '昆明理工大学',
        othOrg: null,

        XRules: {
          required: [
            v => (!this.menu || !!v) || '必填项。'
          ],
          sysOrg: [
            v => (this.orgType !== 'sys' || !!v) || '必填项。'
          ],
          othOrg: [
            v => (this.orgType !== 'oth' || !!v) || '必填项。'
          ]
        }
      }
    },
    watch: {
      "orgType": function (nv) {
        window.console.log(nv);
        if (nv === 'sys') {
          this.othOrg = null;
        } else {
          this.sysOrg ='昆明理工大学';
        }
      }
    },

    methods: {
      onOk() {
        window.console.log("in onOk");
        if (this.$refs.formRef.validate()) {
          if (this.orgType === 'sys') {
            window.console.log(this.sysOrg);
            this.$emit('input', {
              name: this.sysOrg
            });
          }
          else {
            this.$emit('input', {
              name: this.othOrg
            });
          }
          this.menu = false;
          this.othOrg = null;
          this.sysOrg =  null;
          this.$refs.formRef.reset();
        }
      }
    }

  }
</script>
<style>
  div.menu__content.hide-list {
    display: none;
  }
</style>

